  import { createApp } from "vue";
import { createStore } from "vuex";
import login from "@/store/loginModule/login";
import utils from "@/store/utils/utils"
import mixin from "@/store/mixin/mixin"
// Administration
import layoutAdmin from "@/store/layoutAdmin/layoutAdmin";
import moduleSetup from "@/store/module/administration/moduleManagement/moduleSetup";
import subModuleSetup from "@/store/module/administration/moduleManagement/subModuleSetup";
import menuSetup from "@/store/module/administration/moduleManagement/menuSetup";
import roleSetup from "@/store/module/administration/roleManagement/roleSetup";
import rolePermission from "@/store/module/administration/roleManagement/rolePermission";
import branchSetup from "@/store/module/administration/branchManagement/branchSetup.js";
import branchModuleSetup from "@/store/module/administration/branchManagement/branchModuleSetup.js";
import companySetup from "@/store/module/administration/companyManagement/companySetup.js";
import companyModuleSetup from "@/store/module/administration/companyManagement/companyModuleSetup.js";
import userSetup from "@/store/module/administration/userManagement/userSetup";
import warehouseSetup from "@/store/module/inventory/settingsManagement/warehouseSetup";
import brandSetup from "@/store/module/inventory/settingsManagement/brandSetup";
import productTypeSetup from "@/store/module/inventory/settingsManagement/productTypeSetup";
import sizeSetup from "@/store/module/inventory/settingsManagement/sizeSetup";
import categorySetup from "@/store/module/inventory/settingsManagement/categorySetup";
import subCategorySetup from "@/store/module/inventory/settingsManagement/subCategorySetup";
import manufactureSetup from "@/store/module/inventory/settingsManagement/manufactureSetup";
import unitSetup from "@/store/module/inventory/settingsManagement/unitSetup";
// Supplier Management
import supplierSetup from "@/store/module/inventory/supplierManagement/supplierSetup";
import approvalName from "@/store/module/administration/approvalManagement/approvalName";
import approvalMatrix from "@/store/module/administration/approvalManagement/approvalMatrix";
import approvalStepNames from "@/store/module/administration/approvalManagement/approvalStepNames";

// Secondary Unit
import secondaryUnitSetup from "@/store/module/inventory/settingsManagement/secondaryUnitSetup";
import colorSetup from "@/store/module/inventory/settingsManagement/colorSetup"

import productSetup from "@/store/module/inventory/productManagement/productSetup";
import productMapSetup from "@/store/module/inventory/productManagement/productMapSetup";
// Customer Management
import customerSetup from "@/store/module/inventory/customerManagement/customerSetup";
import customerTypeSetup from "@/store/module/inventory/customerManagement/customerTypeSetup";
import customerMapSetup from "@/store/module/inventory/customerManagement/customerMapSetup";

import supplierTypeSetup from "@/store/module/inventory/supplierManagement/supplierTypeSetup";
import supplierMapSetup from "@/store/module/inventory/supplierManagement/supplierMapSetup";

import invRequistion from "@/store/module/inventory/inventoryRequisition/invRequistion";
import invIssue from "@/store/module/inventory/inventoryIssue/invIssue"

// Inventory Direct Receive
import directReceive from "@/store/module/inventory/receiveManagement/directReceive";
import countrySetup from "@/store/module/inventory/settingsManagement/countrySetup";

// Location Management
import divisionSetup from "@/store/module/location/divisionSetup";
import districtSetup from "@/store/module/location/districtSetup";
import upazilaSetup from "@/store/module/location/upazilaSetup";

// Inventory
import itemTransfer from "@/store/module/inventory/itemTransferManagement/itemTransfer";
import inventoryRecords from "@/store/module/inventory/inventoryRecords/inventoryRecords";
import inventoryDetails from "@/store/module/inventory/inventoryDetails/inventoryDetails";
import invRequisitionDelivery from "@/store/module/inventory/deliveryManagement/invRequisitionDelivery";
import invSalesInvoiceDelivery from "@/store/module/inventory/deliveryManagement/invSalesInvoiceDelivery";
import invGatePass from "@/store/module/inventory/gatePassManagement/invGatePass";
import invPurchaseReturn  from "@/store/module/inventory/returnManagement/purchaseReturn";
import invSalesReturn  from "@/store/module/inventory/returnManagement/salesReturn";
import lcReceive from "@/store/module/inventory/receiveManagement/lcReceive";

// HRM
import hrmLetterSetup from "@/store/module/hrm/settingsManagement/hrmLetterSetup";
import hrmDepartmentSetup from "@/store/module/hrm/settingsManagement/hrmDepartmentSetup";
import hrmSectionSetup from "@/store/module/hrm/settingsManagement/hrmSectionSetup";
import hrmDesignationSetup from "@/store/module/hrm/settingsManagement/hrmDesignationSetup";
import hrmEmployeeTypeSetup from "@/store/module/hrm/settingsManagement/hrmEmployeeTypeSetup";
import hrmClaimTypeSetup from "@/store/module/hrm/settingsManagement/hrmClaimTypeSetup";
import hrmBloodGroup from "@/store/module/hrm/settingsManagement/hrmBloodGroup";
import hrmGender from "@/store/module/hrm/settingsManagement/hrmGender";
import hrmReligionType from "@/store/module/hrm/settingsManagement/hrmReligionType";
import hrmMaritalStatus from "@/store/module/hrm/settingsManagement/hrmMaritalStatus";
import hrmAddEmployee from "@/store/module/hrm/employee/hrmAddEmployee";
import hrmNominee from "@/store/module/hrm/employee/hrmNominee";
import hrmEmployeeList from "@/store/module/hrm/employee/hrmEmployeeList";
import hrmEmployeeDetails from "@/store/module/hrm/employee/hrmEmployeeDetails";
import hrmEmployeeSalaryInfo from "@/store/module/hrm/employee/hrmEmployeeSalaryInfo";
import hrmEmployeeHODSetup from "@/store/module/hrm/employee/hrmEmployeeHODSetup";
import hrmIncrement from "@/store/module/hrm/increment/hrmIncrement";
import hrmPromotion from "@/store/module/hrm/promotion/hrmPromotion";
import hrmClaim from "@/store/module/hrm/claims/hrmClaim";
import educationalInfo from "@/store/module/hrm/employee/educationalInfo";
import addressInfo from "@/store/module/hrm/employee/addressInfo";
import previousEmploymentInfo from "@/store/module/hrm/employee/previousEmploymentInfo";
import hrmDropdowns from "@/store/module/hrm/hrmDropdowns";
import hrmEmployeeManagement from "@/store/module/hrm/employee/hrmEmployeeManagement";
import otherInfo from "@/store/module/hrm/employee/otherInfo";
import settingsInfo from "@/store/module/hrm/employee/settingsInfo";
import promotionReport from "@/store/module/hrm/reports/promotionReport";
import nomineeReport from "@/store/module/hrm/reports/nomineeReport";
import employeeSummaryReport from "@/store/module/hrm/reports/employeeSummaryReport";

// Purchase
import purRequsition from "@/store/module/purchase/purchaseRequsition/purRequsition";
import purRequsitionMerge from "@/store/module/purchase/purchaseRequsition/purRequsitionMerge";
import rfq from "@/store/module/purchase/rfq/rfq";
import csQuotation from "@/store/module/purchase/csQuotation/csQuotation";
import purOrder from "@/store/module/purchase/purchaseOrder/purOrder";
import purchaseInvoice from "@/store/module/purchase/purchaseInvoice/purchaseInvoice";
import poReceive from "@/store/module/inventory/receiveManagement/poReceive";
import purLetterInf from "@/store/module/purchase/purLetterInfo/purLetterInfo"
import purSupplierListReport from "@/store/module/purchase/purchaseReports/purSupplierListReport";
import purRequisitionReport from "@/store/module/purchase/purchaseReports/purRequisitionReport";
import purPRApprovalReport from "@/store/module/purchase/purchaseReports/purPRApprovalReport";
import purReqMergeReport from "@/store/module/purchase/purchaseReports/purReqMergeReport";
import purRFQGenReport from "@/store/module/purchase/purchaseReports/purRFQGenReport";
import purCSStateReport from "@/store/module/purchase/purchaseReports/purCSStateReport";
import purCSApprovalReport from "@/store/module/purchase/purchaseReports/purCSApprovalReport";
import purPOOrderReport from "@/store/module/purchase/purchaseReports/purPOOrderReport";
import purPOApprovalReport from "@/store/module/purchase/purchaseReports/purPOApprovalReport";
import purReceiveReport from "@/store/module/purchase/purchaseReports/purReceiveReport";
// Attendance
import shiftSetup from "@/store/module/attendance/settingsManagement/shiftSetup";
import weekendSetup from "@/store/module/attendance/settingsManagement/weekend";
import employeeWeekendSetup from "@/store/module/attendance/settingsManagement/employeeWeekend";
import holidaySetup from "@/store/module/attendance/settingsManagement/holidaySetup";
import daysSetup from "@/store/module/attendance/settingsManagement/daysSetup";
import employeeShiftMapping from "@/store/module/attendance/settingsManagement/employeeShiftMapping";
import roster from "@/store/module/attendance/attendanceManagement/roster/roster";
import attendanceUpload from "@/store/module/attendance/attendanceManagement/attendanceUpload";
import manualAttendance from "@/store/module/attendance/manualAttendance/manualAttendance";
import myDailyAttendanceReport from "@/store/module/attendance/reports/myDailyAttendanceReport";
import attendanceSummaryReport from "@/store/module/attendance/reports/attendanceSummaryReport";
import employeeDailyAttendanceSheet from "@/store/module/attendance/reports/employeeDailyAttendanceSheet";
import overtimeReport from "@/store/module/attendance/reports/overtimeReport";
import lateEarlyReport from "@/store/module/attendance/reports/lateEarlyReport";
import absentReport from "@/store/module/attendance/reports/absentReport";
import attendanceRegisterReport from "@/store/module/attendance/reports/attendanceRegisterReport";
import shiftWiseAttendanceReport from "@/store/module/attendance/reports/shiftWiseAttendanceReport";
import attendanceReconciliationReport from "@/store/module/attendance/reports/attendanceReconciliationReport";
import workforceAvailabilityReport from "@/store/module/attendance/reports/workforceAvailabilityReport";
import attendanceLedgerReport from "@/store/module/attendance/reports/attendanceLedgerReport";
import departmentPerformanceReport from "@/store/module/attendance/reports/departmentPerformanceReport";
import attendanceReconciliation from "@/store/module/attendance/attendanceReconciliationManagement/attendanceReconciliation";
import attendanceRawPunchDataReport from "@/store/module/attendance/reports/attendanceRawPunchDataReport";
import employeeJobCardReport from "@/store/module/attendance/reports/employeeJobCardReport";

//Sales
import addLeads from "@/store/module/sales/crmManagement/addLeads";
import leadSourceTypesSetup from "@/store/module/sales/crmManagement/leadSourceTypesSetup";
import salesLeadStatus from "@/store/module/sales/crmManagement/salesLeadStatus";
import leadDetails from "@/store/module/sales/crmManagement/leadDetails";
import proposals from "@/store/module/sales/crmManagement/proposals";
import leadAssigned from "@/store/module/sales/crmManagement/leadAssigned";
import salesProposalStatus from "@/store/module/sales/crmManagement/proposalStatus";
import salesWorkOrder from "@/store/module/sales/crmManagement/salesWorkOrder";
import salesWorkOrderActivityLog from "./module/sales/crmManagement/salesWorkOrderActivityLog";
import saleOrder from "@/store/module/sales/orderManagement/saleOrder";
import saleInvoice from "@/store/module/sales/orderManagement/saleInvoice";
import evaluationCriteria from "./module/purchase/evaluationCriteria/purEvaluationCriteria";
import slsletterSetup from "./module/sales/settingsManagement/slsletterSetup";
import evalParamGenerate from './module/purchase/supplierSelection/evaluationParamGenerate';
import selectedSupplier from "./module/purchase/supplierSelection/selectedSupplier";
import salesTeam from "./module/sales/targetManagement/salesTeam";
import salesDepartmentTarget from "./module/sales/targetManagement/salesDepartmentTarget";
import salesTeamTarget from "./module/sales/targetManagement/salesTeamTarget";
import salesEmployeeTarget from "./module/sales/targetManagement/salesEmployeeTarget";
import salesFixedPercentageCommission from "@/store/module/sales/commssionSettingsManagement/salesFixedPercentageCommission";
import salesTieredPercentageCommission from "@/store/module/sales/commssionSettingsManagement/salesTieredPercentageCommission";
import salesProductBasedCommission from "@/store/module/sales/commssionSettingsManagement/salesProductBasedCommission";
import salesProfitBasedCommission from "@/store/module/sales/commssionSettingsManagement/salesProfitBasedCommission";

//Accounts
import accountHead from "@/store/module/accounts/settingsManagement/accountHead";
import costCenters from "@/store/module/accounts/settingsManagement/costCenters";
import voucher from "@/store/module/accounts/voucherManagement/voucher";
import party from "@/store/module/accounts/party/party";
import chequeBook from "@/store/module/accounts/chequeBook/chequeBook";
import bank from "@/store/module/accounts/chequeBook/bank";
import bankBranch from "@/store/module/accounts/chequeBook/bankBranch";
import bankAccount from "@/store/module/accounts/chequeBook/bankAccount";
import vatBook from "@/store/module/accounts/vatBookManagement/vatbook";
import taxBook from "@/store/module/accounts/taxBookManagement/taxBook";
import bankReconciliation from "@/store/module/accounts/bankReconciliation/bankReconciliation";
import accountsDropdowns from "@/store/module/accounts/accountsDropdowns";
import balanceSheetReport from "@/store/module/accounts/reports/balanceSheetReport";
import trialBalanceReport from "@/store/module/accounts/reports/trialBalanceReport";
import incomeStatementReport from "@/store/module/accounts/reports/incomeStatementReport";
import cashFlowReport from "@/store/module/accounts/reports/cashFlowReport";
import changesInEquityReport from "@/store/module/accounts/reports/changesInEquityReport";
import receiptAndPaymentReport from "@/store/module/accounts/reports/receiptAndPaymentReport";
import dayBookReport from "@/store/module/accounts/reports/dayBookReport";
import cashBookReport from "@/store/module/accounts/reports/cashBookReport";
import bankBookReport from "@/store/module/accounts/reports/bankBookReport";
import ledgerReport from "@/store/module/accounts/reports/ledgerReport";
import moneyRequisition from "@/store/module/accounts/moneyRequisition/moneyRequisition";
import employeeAdvanceSettlement from "@/store/module/accounts/employeeAdvanceSettlement/employeeAdvanceSettlement";

// Producttion

import productionStyle from "@/store/module/production/masterSetup/style";
import productionPos from "@/store/module/production/masterSetup/pos";
import productionColor from "@/store/module/production/masterSetup/color";
import productionSize from "@/store/module/production/masterSetup/size";
import productDyeing from "@/store/module/production/masterSetup/dyeing";
import productionBom from "@/store/module/production/bom/bom";
import productionCutting from "@/store/module/production/cutting/cutting";
import productionBundle from "@/store/module/production/bundle/bundle";
import productionSewing from "@/store/module/production/sewing/sewing";
import productionQc from "@/store/module/production/qc/qc";
import productionFinishing from "@/store/module/production/finishing/finishing";
import productionBuyerOrder from "@/store/module/production/buyerOrder/buyerOrder";
import productionOrder from "@/store/module/production/productionOrder/productionOrder";
import dyeingOrder from "@/store/module/production/dyeingOrder/dyeingOrder";
import proformaInvoice from "@/store/module/production/proformaInvoice/proformaInvoice";
import masterSalesContact from "@/store/module/production/masterSalesContract/masterSalesContact";
import salesContact from "@/store/module/production/salesContact/salesContact";
import bhpPurchaseOrder from "@/store/module/production/purchaseOrder/purchaseOrder";
import bhpInvoiceBill from "@/store/module/production/invoiceBill/invoiceBill";
import bhpTtAllocation from "@/store/module/production/ttAllocation/ttAllocation";

//Leave Management

import leaveSettings from "@/store/module/leave/settings/leave";
import leaveApplicationForm from "@/store/module/leave/leaveApplication/leaveapplicationForm";
import leaveApplication from "@/store/module/leave/officials/leave";
import leaveRegisterProcess from "@/store/module/leave/leaveRegister/leaveRegisterprocess";
import leaveBalance from "@/store/module/leave/leaveRegister/leaveBalance";
import leaveSummaryReport from "@/store/module/leave/reports/leaveSummaryReport";
import leaveDetailsReport from "@/store/module/leave/reports/leaveDetailsReport";
import leaveEmployeeWiseSummaryReport from "@/store/module/leave/reports/leaveEmployeeWiseSummaryReport";
import leaveEarnedRegisterReport from "./module/leave/reports/leaveEarnedRegisterReport";

//Asset
import assetCategory from "@/store/module/asset/settingsManangement/assetCategory";
import assetDepreciationMethod from "@/store/module/asset/settingsManangement/assetDepreciationMethod";
import assetStatusTypes from "@/store/module/asset/settingsManangement/assetStatusTypes";
import assetLocation from "@/store/module/asset/settingsManangement/assetLocation";
import assetRegistration from "@/store/module/asset/assetRegistration/assetRegistration";
import assetComponents from "@/store/module/asset/assetRegistration/assetComponents";
import assetDepreciation from "@/store/module/asset/assetDepreciation/assetDepreciation";
import assetAccountsMapping from "@/store/module/asset/settingsManangement/assetAccountsMapping";
import assetTransfer from "@/store/module/asset/assetTransfer/assetTransfer";
import assetMaintenance from "@/store/module/asset/assetMaintenance/assetMaintenance";
import assetPreparation from "@/store/module/asset/assetPreparation/assetPreparation";
import assetDisposal from "@/store/module/asset/assetDisposal/assetDisposal";
import assetDocuments from "@/store/module/asset/assetRegistration/assetDocuments";
import assetAssignments from "@/store/module/asset/assetRegistration/assetAssignments";
import assetAcquisition from "@/store/module/asset/assetAcquisition/assetAcquisition";

//Payroll Management
import salaryComponent from "@/store/module/payroll/payrollSettings/salaryComponent";
import salaryProcess from "@/store/module/payroll/salaryProcess/salaryProcess";
import employeeSalary from "@/store/module/payroll/employeeSalary/employeeSalary";
import salaryReadyAttendance from "@/store/module/payroll/salaryReadyAttendance/salaryReadyAttendance";
import bonusProcess from "@/store/module/payroll/bonusProcess/bonusProcess";
import bonusProcessReport from "@/store/module/payroll/bonusReports/bonusProcessReport";
import bonusSummaryRegisterReport from "@/store/module/payroll/bonusReports/bonusSummaryRegisterReport";
import bonusPaymentRegisterReport from "@/store/module/payroll/bonusReports/bonusPaymentRegisterReport";
import bonusBankAdviceReport from "@/store/module/payroll/bonusReports/bonusBankAdviceReport";
import employeeBonusHistoryReport from "@/store/module/payroll/bonusReports/employeeBonusHistoryReport";
import bonusComparativeReport from "@/store/module/payroll/bonusReports/bonusComparativeReport";
import bonusAgingReport from "@/store/module/payroll/bonusReports/bonusAgingReport";
import bonusTrendReport from "@/store/module/payroll/bonusReports/bonusTrendReport";
import paymentOrder from "@/store/module/payroll/salaryPayments/paymentOrder";
import monthlySalaryReport from "@/store/module/payroll/salaryReports/monthlySalaryReport";
import salarySummaryReport from "@/store/module/payroll/salaryReports/salarySummaryReport";
import salaryPayRegisterReport from "@/store/module/payroll/salaryReports/salaryPayRegisterReport";
import salaryBankAdviceReport from "@/store/module/payroll/salaryReports/salaryBankAdviceReport";
import salaryOutstandingReport from "@/store/module/payroll/salaryReports/salaryOutstandingReport";
import salaryAgingReport from "@/store/module/payroll/salaryReports/salaryAgingReport";
import allowanceDeductionBreakupReport from "@/store/module/payroll/salaryReports/allowanceDeductionBreakupReport";
import taxSummaryReport from "@/store/module/payroll/salaryReports/taxSummaryReport";
import salaryTrendReport from "@/store/module/payroll/salaryReports/salaryTrendReport";
import otIncentiveReport from "@/store/module/payroll/salaryReports/otIncentiveReport";
import hrmEmployeeBank from "@/store/module/hrm/settingsManagement/hrmEmployeeBank";
import employeeSalaryHistoryReport from "@/store/module/payroll/salaryReports/employeeSalaryHistoryReport";
import fullPayrollLedger from "@/store/module/payroll/salaryReports/fullPayrollLedger";

//Document
import documentFolder from "@/store/module/document/folderManament/documentFolder";
import documentFile from "@/store/module/document/fileManagement/documentFile";
import documentShare from "@/store/module/document/shareManagement/documentShare";
import documentRecent from "@/store/module/document/recentManagement/documentRecent";
import documentStarred from "@/store/module/document/starredManangement/documentStarred";
import documentArchived from "@/store/module/document/archiveManagement/documentArchived";

//LC Management
import currency from "@/store/module/lc/settingsManagement/currency";
import lcBank from "@/store/module/lc/settingsManagement/lcBank";
import lcPaymentTerm from "@/store/module/lc/settingsManagement/lcPaymentTerm";
import lcIncoterm from "@/store/module/lc/settingsManagement/lcIncoterm";
import lcType from "@/store/module/lc/settingsManagement/lcType";
import lcPort from "@/store/module/lc/settingsManagement/lcPort";
import lcShippingMethod from "@/store/module/lc/settingsManagement/lcShippingMethod";
import lcDocumentType from "@/store/module/lc/settingsManagement/lcDocumentType";
import lcExchangeRate from "@/store/module/lc/settingsManagement/lcExchangeRate";
import lcImportPi from "@/store/module/lc/lcImport/lcImportPi";
import lcImportLcMaster from "@/store/module/lc/lcImport/lcImportLcMaster";
import lcImportLcAmendment from "@/store/module/lc/lcImport/lcImportLcAmendment";
import lcImportLcShipment from "@/store/module/lc/lcImport/lcImportLcShipment";
import lcImportGnr from "@/store/module/lc/lcImport/lcImportGnr";
import lcImportLcCosting from "@/store/module/lc/lcImport/lcImportLcCosting";
import lcImportDocument from "@/store/module/lc/lcImport/lcImportDocument";
import lcExportDocument from "@/store/module/lc/lcExport/lcExportDocument";
import documentsTrash from "@/store/module/document/trashManagement/documentsTrash";
import lcExportLcMaster from "@/store/module/lc/lcExport/lcExportMaster";
import lcExportPi from "@/store/module/lc/lcExport/lcExportPi";
import lcExportCommercialInvoice from "@/store/module/lc/lcExport/lcExportCommercialInvoice";

//Project
import contact from "@/store/module/project/settingManagement/contact";
import author from "@/store/module/project/settingManagement/author";
import activity from "@/store/module/project/settingManagement/activity";
import subActivity from "@/store/module/project/settingManagement/subActivity";
import projectType from "@/store/module/project/settingManagement/projectType";
import projectTheme from "@/store/module/project/settingManagement/projectTheme";
import progressTemplate from "@/store/module/project/settingManagement/progressTemplate";
import project from "@/store/module/project/projectManagement/project";
import projectTraining from "@/store/module/project/projectManagement/projectTraining";
import projectBudget from "@/store/module/project/budgetManagement/projectBudget";

// Resource 
import purpose from "@/store/module/resource/purpose/purpose";

const store = createStore({
  modules: {
    // Login
    login,

    // Util
    utils,

    // Mixin
    mixin,

    //LayoutAdmin
    layoutAdmin,

    // Administration Module
    moduleSetup,
    subModuleSetup,
    menuSetup,
    roleSetup,
    rolePermission,
    branchSetup,
    branchModuleSetup,
    userSetup,
    companySetup,
    companyModuleSetup,
    approvalName,
    approvalMatrix,
    approvalStepNames,

    // Inventory Module
    warehouseSetup,
    brandSetup,
    colorSetup,
    productTypeSetup,
    sizeSetup,
    categorySetup,
    subCategorySetup,
    manufactureSetup,
    unitSetup,

    secondaryUnitSetup,
    productSetup,
    productMapSetup,
    supplierSetup,
    supplierTypeSetup,
    invRequistion,
    invIssue,
    invRequisitionDelivery,
    invSalesInvoiceDelivery,
    invGatePass,
    directReceive,
    poReceive,
    itemTransfer,
    inventoryRecords,
    inventoryDetails,
    invPurchaseReturn,
    invSalesReturn,
    lcReceive,

    supplierMapSetup,
    customerSetup,
    customerTypeSetup,
    customerMapSetup,
    countrySetup,

    // Location Management
    divisionSetup,
    districtSetup,
    upazilaSetup,

    // HRM Module
    hrmLetterSetup,
    hrmEmployeeBank,
    hrmDepartmentSetup,
    hrmSectionSetup,
    hrmDesignationSetup,
    hrmEmployeeTypeSetup,
    hrmClaimTypeSetup,
    hrmBloodGroup,
    hrmGender,
    hrmReligionType,
    hrmMaritalStatus,
    hrmNominee,
    hrmAddEmployee,
    hrmEmployeeList,
    hrmEmployeeDetails,
    hrmEmployeeSalaryInfo,
    hrmEmployeeHODSetup,
    hrmIncrement,
    hrmPromotion,
    hrmClaim,
    educationalInfo,
    addressInfo,
    previousEmploymentInfo,
    hrmDropdowns,
    hrmEmployeeManagement,
    otherInfo,
    settingsInfo,
    promotionReport,
    nomineeReport,
    employeeSummaryReport,

    // Purchase Module
    purRequsition,
    purRequsitionMerge,
    rfq,
    csQuotation,
    purOrder,
    purchaseInvoice,
    purLetterInf,
    evaluationCriteria,
    evalParamGenerate,
    selectedSupplier,
    purSupplierListReport,
    purRequisitionReport,
    purPRApprovalReport,
    purReqMergeReport,
    purRFQGenReport,
    purCSStateReport,
    purCSApprovalReport,
    purPOOrderReport,
    purPOApprovalReport,
    purReceiveReport,

    // Attendance Module
    shiftSetup,
    weekendSetup,
    employeeWeekendSetup,
    holidaySetup,
    daysSetup,
    employeeShiftMapping,
    attendanceReconciliation,
    attendanceUpload,
    manualAttendance,
    attendanceSummaryReport,
    employeeDailyAttendanceSheet,
    overtimeReport,
    lateEarlyReport,
    absentReport,
    attendanceRegisterReport,
    attendanceRawPunchDataReport,
    employeeJobCardReport,
    shiftWiseAttendanceReport,
    myDailyAttendanceReport,
    attendanceReconciliationReport,
    workforceAvailabilityReport,
    attendanceLedgerReport,
    departmentPerformanceReport,
    roster,

    //Sales Module
    slsletterSetup,
    salesFixedPercentageCommission,
    salesTieredPercentageCommission,
    salesProductBasedCommission,
    salesProfitBasedCommission,
    addLeads,
    leadSourceTypesSetup,
    salesLeadStatus,
    leadDetails,
    proposals,
    leadAssigned,
    salesProposalStatus,
    salesWorkOrder,
    salesWorkOrderActivityLog,
    saleOrder,
    saleInvoice,
    salesTeam,
    salesDepartmentTarget,
    salesTeamTarget,
    salesEmployeeTarget,
    
    // Accounts
    accountHead,
    voucher,
    costCenters,
    party,
    bank,
    bankBranch,
    bankAccount,
    chequeBook,
    vatBook,
    taxBook,
    bankReconciliation,
    accountsDropdowns,
    moneyRequisition,
    balanceSheetReport,
    trialBalanceReport,
    incomeStatementReport,
    cashFlowReport,
    changesInEquityReport,
    receiptAndPaymentReport,
    dayBookReport,
    cashBookReport,
    bankBookReport,
    ledgerReport,
    employeeAdvanceSettlement,

    // Production
    productionStyle,
    productionPos,
    productionColor,
    productionSize,
    productDyeing,
    productionBom,
    productionCutting,
    productionBundle,
    productionSewing,
    productionQc,
    productionFinishing,
    productionBuyerOrder,
    productionOrder,
    dyeingOrder,
    proformaInvoice,
    masterSalesContact,
    salesContact,
    bhpPurchaseOrder,
    bhpInvoiceBill,
    bhpTtAllocation,
    
    //Asset
    assetCategory,
    assetDepreciationMethod,
    assetStatusTypes,
    assetLocation,
    assetAccountsMapping,
    assetRegistration,
    assetComponents,
    assetDepreciation,
    assetTransfer,
    assetMaintenance,
    assetPreparation,
    assetDisposal,
    assetDocuments,
    assetAssignments,
    assetAcquisition,

    //Leave
    leaveSettings,
    leaveApplicationForm,
    leaveApplication,
    leaveRegisterProcess,
    leaveBalance,
    leaveSummaryReport,
    leaveDetailsReport,
    leaveEmployeeWiseSummaryReport,
    leaveEarnedRegisterReport,

    //Payroll
    salaryComponent,
    salaryProcess,
    employeeSalary,
    salaryReadyAttendance,
    bonusProcess,
    bonusProcessReport,
    bonusSummaryRegisterReport,
    bonusPaymentRegisterReport,
    bonusBankAdviceReport,
    employeeBonusHistoryReport,
    bonusComparativeReport,
    bonusAgingReport,
    bonusTrendReport,
    paymentOrder,
    monthlySalaryReport,
    salarySummaryReport,
    salaryPayRegisterReport,
    salaryBankAdviceReport,
    salaryOutstandingReport,
    salaryAgingReport,
    allowanceDeductionBreakupReport,
    taxSummaryReport,
    salaryTrendReport,
    otIncentiveReport,
   fullPayrollLedger,
    employeeSalaryHistoryReport,

    //Document
    documentFolder,
    documentFile,
    documentRecent,
    documentShare,
    documentStarred,
    documentArchived,
    documentsTrash,

    //LC Management
    currency,
    lcBank,
    lcPaymentTerm,
    lcIncoterm,
    lcType,
    lcPort,
    lcShippingMethod,
    lcDocumentType,
    lcExchangeRate,
    lcImportPi,
    lcImportLcMaster,
    lcImportLcAmendment,
    lcImportLcShipment,
    lcImportGnr,
    lcImportLcCosting,
    lcImportDocument,
    lcExportDocument,
    lcExportLcMaster,
    lcExportPi,
    lcExportCommercialInvoice,

    
     //Project Module
    author,
    contact,
    projectType,
    projectTheme,
    progressTemplate,
    activity,
    subActivity,
    project,
    projectTraining,
    projectBudget,

    // Resource
    purpose

  },
});


const app = createApp({ /* your root component */ })
app.use(store)

export default store;